import { render, staticRenderFns } from "./ordersList.vue?vue&type=template&id=59898fac"
import script from "./ordersList.vue?vue&type=script&lang=js"
export * from "./ordersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports